import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ButtonStyleTypes } from '../../atoms/buttons/enums.js';
import { setDataAttributes, isRTL, getContainerClass } from '../../utilities/dom-helpers/index.js';
import { setLineClamp } from '../../../generated/global-content/components/utilities/text-helpers/index.js';
import css_248z$1 from './styles/groupsite-icon-and-info.scss.js';
import css_248z from './styles/icon-and-info.scss.js';

class IconAndInfo extends s {
    constructor() {
        super(...arguments);
        this.styleType = ButtonStyleTypes.LIGHT;
        this.rtl = false;
        this.roundIcon = false;
        this.headingSlot = null;
        this.textSlot = null;
        this.size = '';
        this.isIcon = false;
        this.templateType = 'classic';
        this.enableShadow = false;
        this.background = 'default';
    }
    firstUpdated() {
        setDataAttributes(this, 'heading', 'text');
        setLineClamp(this, 99, 299);
    }
    render() {
        const classes = {
            [this.styleType]: this.styleType,
            rtl: this.rtl || isRTL(),
            'icon-and-info-container': true,
            lighthouse: this.templateType === 'lighthouse',
            shadow: this.enableShadow,
            'background-white': this.background === 'white',
        };
        const renderIconClass = () => this.templateType === 'lighthouse'
            ? 'lighthouse-icon'
            : getContainerClass(this.isIcon, this.size);
        return x `<div class="${o(classes)}"><div class="${renderIconClass()}"><slot name="icon"></slot></div><slot name="heading"></slot><slot name="text"></slot><slot name="cta"></slot></div>`;
    }
}
IconAndInfo.styles = [css_248z, css_248z$1];
__decorate([
    n({ type: String })
], IconAndInfo.prototype, "styleType", void 0);
__decorate([
    n({ type: Boolean })
], IconAndInfo.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean })
], IconAndInfo.prototype, "roundIcon", void 0);
__decorate([
    t()
], IconAndInfo.prototype, "headingSlot", void 0);
__decorate([
    t()
], IconAndInfo.prototype, "textSlot", void 0);
__decorate([
    n({ type: String })
], IconAndInfo.prototype, "size", void 0);
__decorate([
    n({ type: Boolean })
], IconAndInfo.prototype, "isIcon", void 0);
__decorate([
    n({ type: String })
], IconAndInfo.prototype, "templateType", void 0);
__decorate([
    n({ type: Boolean })
], IconAndInfo.prototype, "enableShadow", void 0);
__decorate([
    n({ type: String })
], IconAndInfo.prototype, "background", void 0);
customElements.define('icon-and-info', IconAndInfo);

export { IconAndInfo };
